import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TransmedProcessSlide from "./slide";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { TransmedReceivingDetailWithProblems } from "../../../../dtos/transmed/process/receivingDetail";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";
import { useEffect, useState } from "react";

function TransmedProcessConfirmed(props: {
  details: TransmedReceivingDetailWithProblems[];
  registration: TransmedRegistration;
  deadline: Date;
  startNext: Date;
  endNext: Date;
}) {
  const [preferredDetails, setPreferredDetails] =
    useState<TransmedReceivingDetailWithProblems>(
      props.details.find(
        (detail) => detail.receiver === props.registration.preferred_lc?.id
      )!
    );
  const [confirmedDetails, setConfirmedDetails] =
    useState<TransmedReceivingDetailWithProblems>(
      props.details.find(
        (detail) => detail.receiver === props.registration.confirmed_lc?.id
      )!
    );

  useEffect(() => {
    setPreferredDetails(
      props.details.find(
        (detail) => detail.receiver === props.registration.preferred_lc?.id
      )!
    );
    setConfirmedDetails(
      props.details.find(
        (detail) => detail.receiver === props.registration.confirmed_lc?.id
      )!
    );
  }, [props.details, props.registration]);

  return (
    <TransmedProcessSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "var(--gap-medium)",
      }}
    >
      <h3>Înscrieri în desfășurare</h3>
      <div>Te-ai înscris pentru</div>
      <h1>{props.registration.confirmed_lc?.city || "Necunoscut"} </h1>
      <div style={{ marginTop: "calc(var(--gap-xs) - var(--gap-medium))" }}>
        (
        {props.registration.confirmed_lc_accomodation
          ? "cu cazare"
          : "fără cazare"}
        )
      </div>
      <div style={{ color: "red" }}>
        Vei putea fi acceptat pe locul ales începând cu:{" "}
        <b>{props.deadline.toLocaleTimeString("RO-ro")}</b>
      </div>
      {((props.registration.confirmed_lc_accomodation
        ? confirmedDetails.accomodation_yes
        : confirmedDetails.accomodation_no) ?? 1) <= 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--gap-small)",
            textAlign: "justify",
          }}
        >
          <div>
            Nu au mai rămas locuri disponibile la opțiunea aleasă de tine. În{" "}
            <b style={{ color: "red" }}>
              {props.startNext.toLocaleDateString("RO-ro")}{" "}
              {props.startNext.toLocaleTimeString("RO-ro")} -{" "}
              {props.endNext.toLocaleTimeString("RO-ro")}
            </b>{" "}
            va trebui să accesezi din nou platforma pentru a-ți alege un nou
            loc.
          </div>
        </div>
      ) : (
        <>
          {(props.registration.confirmed_lc_accomodation
            ? confirmedDetails.warning_yes
            : confirmedDetails.warning_no) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "var(--gap-small)",
                textAlign: "justify",
              }}
            >
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="yellow"
                size="xl"
              />
              <div>
                <b>Atenție!</b> Ai selectat o opțiune cu locuri limitate! Există
                șansa să nu prinzi loc aici. În cazul în care participanții cu
                punctaj mai mare vor alege opțiunea aleasă de tine și locurile
                se vor epuiza, va trebui din nou să-ți selectezi centrul, în{" "}
                <b style={{ color: "red" }}>
                  {props.startNext.toLocaleDateString("RO-ro")}{" "}
                  {props.startNext.toLocaleTimeString("RO-ro")} -{" "}
                  {props.endNext.toLocaleTimeString("RO-ro")}
                </b>
                . Nu te teme, însă, nimeni cu punctaj mai mic nu va alege
                destinația înaintea ta! Fii pe fază totuși, întrucât vei pierde
                locul dacă nu îl vei selecta atunci!
              </div>
            </div>
          )}
          {props.registration.confirmed_lc?.id !==
            props.registration.preferred_lc?.id &&
            props.registration.confirmed_lc_accomodation !==
              props.registration.preferred_lc_accomodation &&
            ((props.registration.preferred_lc_accomodation
              ? preferredDetails.accomodation_yes
              : confirmedDetails.accomodation_no) ?? 1) > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "var(--gap-small)",
                  textAlign: "justify",
                }}
              >
                <div>
                  Încă există locuri disponibile la prima ta opțiune. În cazul
                  în care acestea se eliberează, vei avea posibilitatea să alegi
                  dintre ele în{" "}
                  <b style={{ color: "red" }}>
                    {props.startNext.toLocaleDateString("RO-ro")}{" "}
                    {props.startNext.toLocaleTimeString("RO-ro")} -{" "}
                    {props.endNext.toLocaleTimeString("RO-ro")}
                  </b>
                  . Nu te teme, însă, locul ales pentru{" "}
                  {props.registration.confirmed_lc?.city ?? "Necunoscut"} va
                  rămâne al tău, chiar și dacă nu vei mai răspunde.
                </div>
              </div>
            )}
        </>
      )}
    </TransmedProcessSlide>
  );
}

export default TransmedProcessConfirmed;
